import { render, staticRenderFns } from "./UsersTopNav.vue?vue&type=template&id=48f59a55"
import script from "./UsersTopNav.vue?vue&type=script&lang=js"
export * from "./UsersTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports